import { AreaData, Time } from "lightweight-charts";

export const convertChartData = (chartData: number[][] = []): AreaData<Time>[] => {
  if (!Array.isArray(chartData)) return [];

  return chartData
    .filter((item) => item.length >= 2)
    .map(([time, value]) => ({
      time: time as Time,
      value: Number(value),
    }))
    .sort((a, b) => (a.time as number) - (b.time as number));
};

export function getDateRange(duration: string) {
  const toDate = new Date();
  const fromDate = new Date(toDate);

  switch (duration) {
    case "1D":
      break;
    case "5D":
      fromDate.setDate(toDate.getDate() - 4);
      break;
    case "1M":
      fromDate.setMonth(toDate.getMonth() - 1);
      break;
    case "3M":
      fromDate.setMonth(toDate.getMonth() - 3);
      break;
    case "6M":
      fromDate.setMonth(toDate.getMonth() - 6);
      break;
    case "1Y":
      fromDate.setFullYear(toDate.getFullYear() - 1);
      break;
    default:
      throw new Error("Invalid duration");
  }

  return {
    fromDate: fromDate.toISOString().split("T")[0],
    toDate: toDate.toISOString().split("T")[0],
  };
}
